// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwFlexbox-wrap","verticalAlign":"CwFlexbox-verticalAlign","horizontalAlign":"CwFlexbox-horizontalAlign","column":"CwFlexbox-column","leftAlign":"CwFlexbox-leftAlign","centerAlign":"CwFlexbox-centerAlign","rightAlign":"CwFlexbox-rightAlign"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwflexbox/CwFlexbox.scss
// module id = 368
// module chunks = 0